import { render } from "./IndexFooter.vue?vue&type=template&id=68c5bed6&scoped=true"
import script from "./IndexFooter.vue?vue&type=script&lang=js"
export * from "./IndexFooter.vue?vue&type=script&lang=js"

import "./IndexFooter.vue?vue&type=style&index=0&id=68c5bed6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c5bed6"]])

export default __exports__